import React, { useMemo } from 'react';

import { groupCartItemsByProductPackage, groupSaleItemsByProductPackage, type CartItem } from '@src/domains/cart';
import type { DetailedSaleItem } from '@src/domains/orders';

import { SummaryItemCard } from './SummaryItemCard';
import { SummaryPackageCard } from './SummaryPackageCard';
import { isCartLineItem, type SummaryLineItem } from '@src/features/transactables/summary/core/summaryLineItem';
import { SummaryRoot } from '../styles';

type SummaryItemsListProps = {
  items: SummaryLineItem[];
};

export const SummaryItemsList = (props: SummaryItemsListProps) => {
  const { items } = props;

  const grouped = useMemo(() => {
    const hasCartItems = items.some(isCartLineItem);

    if (hasCartItems) {
      return groupCartItemsByProductPackage(items as CartItem[]);
    }

    return groupSaleItemsByProductPackage(items as DetailedSaleItem[]);
  }, [items]);

  if (!items.length) {
    return null;
  }

  return (
    <SummaryRoot data-testid='summary-items-list'>
      {grouped.packages.map((packageItem, index) => (
        <SummaryPackageCard
          key={`${packageItem.productPackage.id}-${index}`}
          productPackage={packageItem.productPackage}
          items={packageItem.items as SummaryLineItem[]}
        />
      ))}

      {grouped.nonPackageItems?.map((item) => (
        <SummaryItemCard key={item.id} item={item as SummaryLineItem} />
      ))}
    </SummaryRoot>
  );
};

export default SummaryItemsList;
